import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface UnifiedLoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  text?: string;
  className?: string;
  fullScreen?: boolean;
}

export const UnifiedLoadingSpinner = ({ 
  size = "md", 
  text, 
  className,
  fullScreen = false
}: UnifiedLoadingSpinnerProps) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6", 
    lg: "h-8 w-8",
    xl: "h-12 w-12"
  };

  const textClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
    xl: "text-xl"
  };

  const content = (
    <div className={cn("flex flex-col items-center justify-center gap-3", className)}>
      <Loader2 className={cn("animate-spin text-orange-600", sizeClasses[size])} />
      {text && (
        <p className={cn("text-orange-600 font-medium", textClasses[size])}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center" dir="rtl">
        {content}
      </div>
    );
  }

  return content;
};